import React from 'react';
import { Button } from '@mui/material';

export default function DigitalCert({ currentActive, setNextStep }) {

    const steps = [
        {
            text: "After submitting the google form with the proof of transaction, a digital certificate will be issued within 1 - 2 business days.",
        },
    ];

    return (
        <div className="card w-100 my-3">
            <div className="card-body">
                <h3 className="card-title">
                    Redeeming Digital Certificate
                </h3>
                {
                    steps.map((x, i) => {
                        return (
                            <div key={i} className="d-flex flex-row">
                                <p className='donations-list'>{i + 1}</p>
                                <p className="ms-2 w-100">{x.text}
                                </p>
                            </div>
                        );
                    })
                }
                <Button className='me-2' variant="contained" disableElevation onClick={() => setNextStep(currentActive - 1)}>Back</Button>
            </div>
        </div>
    )
}
